import { render, staticRenderFns } from "./AssignAccountsRequiringRebuild.vue?vue&type=template&id=6804e36a&scoped=true"
import script from "./AssignAccountsRequiringRebuild.vue?vue&type=script&lang=js"
export * from "./AssignAccountsRequiringRebuild.vue?vue&type=script&lang=js"
import style0 from "./AssignAccountsRequiringRebuild.vue?vue&type=style&index=0&id=6804e36a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6804e36a",
  null
  
)

export default component.exports